import React from "react";
import { Box, Chip } from "@mui/material";
import { SDLSUrl } from "../../../../config";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";

const base_url = SDLSUrl.uri;

const DeviceLockActionsTable = () => {
  const actions = {
    entity: "Device Lock Audit Logs",
    dataObject: {
      ignoreFields: ["RequestPayload"],
      objectName: "allDeviceLockActions",
      inputObjectName: "param",
      parameters: {},
    },
    isSubRight: true,
    showStatus: false,
    showMore: {
      search: true,
      min: 0,
      max: 0,
    },
  };

  return (
    <Box m="20px">
      <DynamicTableForJson
        title="Device Lock Audit Logs"
        subtitle="Remote Lock / Unlock / Notify Actions History"
        actions={actions}
        base_url={base_url}
      />
    </Box>
  );
};

export default DeviceLockActionsTable;
